<template>
  <div>

    <jx-hanghai-ke-hoach-dieu-dong
      :type="type"
      :documentTypeCode="documentTypeCode"
      :documentStatusCode="documentStatusCode"
      :stateDisplay="stateDisplay"
      v-if="stateDisplay === 'KeHoachDieuDongTau2'"
      ref="KeHoachDieuDongTau2"
      >
    </jx-hanghai-ke-hoach-dieu-dong>

    <jx-hanghai-ke-hoach-dieu-dong-2
      :type="type"
      :documentTypeCode="documentTypeCode"
      :documentStatusCode="documentStatusCode"
      :stateDisplay="stateDisplay"
      v-else-if="stateDisplay === 'KeHoachDieuDongTau'"
      ref="KeHoachDieuDongTau"
      >
    </jx-hanghai-ke-hoach-dieu-dong-2>

    <!-- <jx-hanghai-ke-hoach-dieu-dong
        :type="type"
        :documentTypeCode="documentTypeCode"
        :documentStatusCode="documentStatusCode"
        :stateDisplay="stateDisplay"
        v-if="stateDisplay === 'KeHoachDieuDongTau'"
        ref="KeHoachDieuDongTau"
        >
      </jx-hanghai-ke-hoach-dieu-dong>

      <jx-hanghai-ke-hoach-dieu-dong-2
        :type="type"
        :documentTypeCode="documentTypeCode"
        :documentStatusCode="documentStatusCode"
        :stateDisplay="stateDisplay"
        v-else-if="stateDisplay === 'KeHoachDieuDongTau2'"
        ref="KeHoachDieuDongTau2"
        >
      </jx-hanghai-ke-hoach-dieu-dong-2> -->

    <jx-hanghai-tau-trong-cang
      :type="type"
      :documentTypeCode="documentTypeCode"
      :documentStatusCode="documentStatusCode"
      :stateDisplay="stateDisplay"
      v-else-if="stateDisplay === 'TauTrongCang'"
      ref="TauTrongCang"
    ></jx-hanghai-tau-trong-cang>

    <jx-hanghai-vi-tri-tau-roi-cang
      :type="type"
      :documentTypeCode="documentTypeCode"
      :documentStatusCode="documentStatusCode"
      :stateDisplay="stateDisplay"
      v-else
      ref="ViTriTauTaiCang"
      >
    </jx-hanghai-vi-tri-tau-roi-cang>

  </div>
</template>

<script>
import supportData from '../store/support_data.json'
import ViTriTauTaiCang from '@/components/ViTriTauTaiCang.vue'
import KeHoachDieuDongTau from '@/components/KeHoachDieuDongTau.vue'
import KeHoachDieuDongTau2 from '@/components/KeHoachDieuDongTau_2.vue'
import TauTrongCang from '@/components/TauTrongCang.vue'
// import axios from 'axios'

export default {
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: '',
    id: ''
  },
  computed: {
    drawer: {
      get () {
        return this.$store.getters.drawer
      },
      set (val) {
        this.$store.commit('setDrawer', val)
      }
    }
  },
  components: {
    'jx-hanghai-vi-tri-tau-roi-cang': ViTriTauTaiCang,
    'jx-hanghai-ke-hoach-dieu-dong': KeHoachDieuDongTau,
    'jx-hanghai-ke-hoach-dieu-dong-2': KeHoachDieuDongTau2,
    'jx-hanghai-tau-trong-cang': TauTrongCang
  },
  data: () => ({
    docTypes: [],
    roleFilterStatus: [],
    initData: null,
    counterHoSoAll: '',
    counterHoSoKeHoachTable: '',
    counterHoSoThuTucTable: '',
    cang_vu_name: '',
    tau_den_rois: [],
    quoc_tichs: supportData.data_state,
    khu_cuc_cangs: [],
    cang_den_tiep_theos: [],
    callBack: true,
    getFilterADVDataAPI: '',
    showAdv: false,
    stateViewFilterLeft: false,
    maritimeCode: 0
  }),
  beforeCreate () {
    var vm = this
    vm.$nextTick(function () {
      vm.$store.dispatch('loadInitResource').then(function (result) {
        vm.initData = result
        if (vm.initData !== null) {
          // vm.getFilterADVDataAPI = vm.initData.getFilterADVDataAPI
          // vm.counterHoSoAll = vm.initData.counterHoSoAll
          // vm.counterHoSoKeHoachTable = vm.initData.counterHoSoKeHoachTable
          // vm.counterHoSoThuTucTable = vm.initData.counterHoSoThuTucTable
          // vm.cang_vu_name = vm.initData.user['cangVuName']
          // let emailNameHeader = document.getElementById('emailNameHeader')
          // if (emailNameHeader !== null && emailNameHeader !== undefined && emailNameHeader !== 'undefined') {
          //   emailNameHeader.innerHTML = vm.initData.user.userName
          // }
        }
      })
    })
  },
  created () {
    var vm = this
    vm.$nextTick(function () {
    })
  },
  updated () {
    let vm = this
    vm.$nextTick(function () {
      vm.loadMaritimeCode()
    })
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
    }
  },
  methods: {
    loadMaritimeCode: function (query) {
      var vm = this
      let param = {
      }
      param['isDelete'] = 0
      param['start'] = -1
      param['end'] = -1
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0
            resolve(result[0])
          } else {
            resolve({})
          }
        }).catch(function (xhr) {
          console.log(xhr)
          reject(false)
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// HomeTraCuu.vue?c7443c1c